import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

export default function SoftUIButtonWithDesc({
  title = "Start",
  description = "Begin the process",
  onClick,
  color = "gray",
}) {
  return (
    <SoftButton
    //   color={color}
      variant="contained"
      fullWidth
      onClick={onClick}
    >
      <SoftBox textAlign="center" py={1}>
        <SoftTypography
          variant="h6"
          fontWeight="bold"
        //   color="black"
        >
          {title}
        </SoftTypography>

        <SoftTypography
          variant="caption"
        //   color="grey"
          opacity={0.8}
        >
          {description}
        </SoftTypography>
      </SoftBox>
    </SoftButton>
  );
}
